import { createBaseQuery } from "../helper/createBaseQuery";
import { tokenSlice } from "../slice/tokenSlice";
import { convertMultipleIds, validateQueryStringParameters } from "../../helpers/api";

const RFQApi = tokenSlice.injectEndpoints({
    reducerPath: "rfqApi",
    baseQuery: createBaseQuery(),
    tagTypes: ["RFQ"],
    endpoints(builder) {
        return {

            getRFQBusinessCategory: builder.query({
                query: () => ({
                    url: `RFQ/GetBusinessCategories`,
                    method: "GET",
                }),
                providesTags: ["RFQ"],
            }),
            getRFQ: builder.query({
                query: (params) => ({
                    url: 'RFQ/GetAll',
                    method: 'GET',
                    params: validateQueryStringParameters(params)
                }),
                providesTags: ["RFQ"],
            }),
            getRFQDraft: builder.query({
                query: (params) => ({
                    url: 'RFQ',
                    method: 'GET',
                    params: validateQueryStringParameters(params)
                }),
                providesTags: ["RFQ"],
            }),
            getRFQProgress: builder.query({
                query: (params) => ({
                    url: 'RFQ/GetInProgress',
                    method: 'GET',
                    params: validateQueryStringParameters(params)
                }),
                providesTags: ["RFQ"],
            }),
            getRFQVendors: builder.query({
                query: (params) => ({
                    url: `RFQ/GetVendorsToSend`,
                    params: validateQueryStringParameters(params),
                    method: 'GET',
                }),
                providesTags: ["RFQ"],
            }),
            getAllVendors: builder.query({
                query: () => ({
                    url: `Vendor/Vendors`,
                    method: 'GET',
                }),
                providesTags: ["Vendor"],
            }),
            getRFQSingleReasons: builder.query({
                query: () => ({
                    url: `RFQ/GetSingleSourceReasons`,
                    method: 'GET',
                }),
                providesTags: ["RFQ"],
            }),
            getRFQById: builder.query({
                query: (id) => {
                    return {
                        url: `RFQ/Get/${id}`,
                        method: 'GET',
                    }
                },
                providesTags: ["RFQ"],
            }),
            deleteRFQ: builder.mutation({
                query: (data) => ({
                    url: `RFQ${convertMultipleIds(data, 'rfqMainId')}`,
                    method: "DELETE",
                }),
                invalidatesTags: ["RFQ"],
            }),
            getRuom: builder.query({
                query: (businessUnitCode) => ({
                    url: `UOM/${businessUnitCode}`,
                    method: "GET",
                }),
                providesTags: ["RFQ"],
            }),
            getRFQRequests: builder.query({
                query: (params) => ({
                    url: `RFQ/GetRequestForRFQ${convertMultipleIds(params, 'businessCategoryIds')}${convertMultipleIds(params, 'buyer', true)}&businessUnitId=${params.businessUnitId}`,
                    method: "GET",
                }),
                providesTags: ["RFQ"],
            }),
            getBuyers: builder.query({
                query: (businessUnitCode) => ({
                    url: `Buyer/GetBuyers/${businessUnitCode}`,
                    method: "GET",
                }),
                providesTags: ["RFQ"],
            }),
            postRFQ: builder.mutation({
                query: (data) => ({
                    url: "RFQ",
                    method: "POST",
                    body: data,
                }),
                invalidatesTags: ["RFQ"],
            }),
            sendVendor: builder.mutation({
                query: (data) => ({
                    url: "RFQ/SaveRFQVendors",
                    method: "POST",
                    body: data,
                }),
                invalidatesTags: ["RFQ"],
            }),
            getConversion: builder.query({
                query: (params) => ({
                    url: `RFQ/GetConversionList`,
                    params,
                    method: "GET",
                }),
                providesTags: ["RFQ"],
            }),
            getRfqAttachments: builder.query({
                query: (sourceId) => ({
                    url: `Attachment/GetRFQAttachments?sourceId=${sourceId}`,
                    method: "GET",
                }),
                providesTags: ["Attachment"],
            }),
            postVendorRfqRetrieve: builder.mutation({
                query: (data) => {
                    return {
                        url: `RFQ`,
                        method: 'POST',
                        body: data,
                    }
                },

                providesTags: ['RFQ'],
            }),
        };
    },
});

export const {
    useGetRFQBusinessCategoryQuery,
    useGetRFQQuery,
    useGetRFQByIdQuery,
    useGetRFQProgressQuery,
    useGetRFQDraftQuery,
    useGetRFQVendorsQuery,
    useGetAllVendorsQuery,
    useGetRFQSingleReasonsQuery,
    useDeleteRFQMutation,
    useGetRuomQuery,
    useGetConversionQuery,
    useGetRFQRequestsQuery,
    useGetBuyersQuery,
    useGetRfqAttachmentsQuery,
    usePostRFQMutation,
    useSendVendorMutation,
    usePostVendorRfqRetrieveMutation
} = RFQApi;
export { RFQApi };
